import { Routes } from '@angular/router';
import { EmissionsPageComponent } from './emissions-page.component';

export const EmissionsPageRouteName = {
  Main: 'emissions',
  Information: 'information',
};

export const EMISSIONS_ROUTES: Routes = [
  {
    path: '',
    component: EmissionsPageComponent,
    children: [
      {
        path: ':id',
        pathMatch: 'full',
        redirectTo: `:id/${EmissionsPageRouteName.Information}`,
      },
    ],
  },
];
